import { STATUS_RANK, viewStatus, displayKind } from './fileStatus.js'

export const SORT_COLUMNS = [
  { key: 'name', label: 'Name', text: true, value: f => f.name || null },
  { key: 'kind', label: 'File type', text: true, value: f => displayKind(f) || null },
  { key: 'pages', label: 'Pages', value: f => f.pageCount ?? null },
  { key: 'size', label: 'Size', value: f => f.sizeBytes ?? null },
  { key: 'date', label: 'Document date', text: true, value: f => f.effectiveDate || null },
  { key: 'status', label: 'Status', value: (f, running) => STATUS_RANK[viewStatus(f, running)] ?? null }
]
const COLUMN = Object.fromEntries(SORT_COLUMNS.map(s => [s.key, s]))

export const EMPTY_FILTER = { name: '', kinds: [], statuses: [] }

export const nextSort = (sort, key) => (sort?.key !== key ? { key, dir: 'asc' } : sort.dir === 'asc' ? { key, dir: 'desc' } : null)

export const sortLabel = sort => (sort ? (COLUMN[sort.key]?.label ?? '') : '')

const compareText = (a, b) => String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' })

export function sortFiles(files, sort, running = {}) {
  const col = sort && COLUMN[sort.key]
  if (!col) return files
  const sign = sort.dir === 'desc' ? -1 : 1
  return [...files].sort((x, y) => {
    const a = col.value(x, running[x.id])
    const b = col.value(y, running[y.id])
    if (a === null || b === null) return a === b ? 0 : a === null ? 1 : -1
    return sign * (col.text ? compareText(a, b) : a - b)
  })
}

const matches = (f, filter, running) =>
  (!filter.name || f.name.toLowerCase().includes(filter.name.trim().toLowerCase())) &&
  (!filter.kinds.length || filter.kinds.includes(displayKind(f))) &&
  (!filter.statuses.length || filter.statuses.includes(viewStatus(f, running[f.id])))

export const filterFiles = (files, filter = EMPTY_FILTER, running = {}) =>
  filterCount(filter) === 0 ? files : files.filter(f => matches(f, filter, running))

const KIND_ORDER = ['TXT', 'DOCX', 'PDF', 'EML']
const kindRank = k => KIND_ORDER.indexOf(k) + 1 || KIND_ORDER.length
export const kindsIn = files => [...new Set(files.map(displayKind).filter(Boolean))].sort((a, b) => kindRank(a) - kindRank(b) || a.localeCompare(b))

export const filterCount = (filter = EMPTY_FILTER) => (filter.name.trim() ? 1 : 0) + filter.kinds.length + filter.statuses.length

export const displayedFiles = (files, { sort = null, filter = EMPTY_FILTER } = {}, running = {}) =>
  sortFiles(filterFiles(files, filter, running), sort, running)
